var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"slide","enter-class":_vm.$style.enter,"leave-class":_vm.$style.leave,"enter-to-class":_vm.$style.enterTo,"leave-to-class":_vm.$style.leaveTo,"enter-active-class":_vm.$style.enterActive,"leave-active-class":_vm.$style.leaveActive}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }